var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33337 16C6.33337 18.2091 8.12423 20 10.3334 20H14.3334C16.5425 20 18.3334 18.2091 18.3334 16C18.3334 13.7909 16.5425 12 14.3334 12H10.3334C8.12424 12 6.33337 10.2091 6.33337 8C6.33337 5.79086 8.12423 4 10.3334 4H14.3334C16.5425 4 18.3334 5.79086 18.3334 8M12.3334 2V22",
    stroke: "#202B72",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.eb84431808409042f9f2ec1d68946f41.svg";
export { ForwardRef as ReactComponent };